import { makeAutoObservable } from "mobx";
import { Step } from "../steps/v2/step";
import { ModalChoice, QuestionChoice } from "@common/models";
import { EventEmitter } from "@/lib/events/eventEmitter";
import { TourFinishManagerEvents, TourFinishManagerNamespace } from "./tourFinishManager.events";

export class TourFinishManager {
  currentStep?: Step;
  stopListenStepEvents?: () => void;
  events = new EventEmitter<typeof TourFinishManagerNamespace, TourFinishManagerEvents, any>(
    TourFinishManagerNamespace
  );

  constructor() {
    makeAutoObservable(this);
  }

  setCurrentStep(step: Step, isLastStep: boolean) {
    if (this.currentStep?.id === step.id) return;

    this.clearCurrentStep();
    this.currentStep = step;

    this.stopListenStepEvents = step.events.on("*", (event, { payload }) => {
      const isChoiceTypeIn = (choiceTypes: (QuestionChoice | ModalChoice)["type"][]) => {
        return choiceTypes.includes((payload as { choice: QuestionChoice | ModalChoice }).choice.type);
      };

      const isQuestionAnswered = step.attributes.type === "question" && event === "questionAnswered";
      const isModalAnswered = step.attributes.type === "modal" && event === "modalAnswered";
      const isQuestionOrModalAnswered = isQuestionAnswered || isModalAnswered;
      const isFinishTourChoiceSelected = isQuestionOrModalAnswered && isChoiceTypeIn(["finishTour"]);

      if (!isLastStep && !isFinishTourChoiceSelected) {
        return;
      }

      if (isQuestionOrModalAnswered && !isChoiceTypeIn(["suspendTour"])) {
        this.events.emit("finished", {});
        return;
      }

      if (!step.isBlockingStepType && event === "initialized") {
        this.events.emit("finished", {});
        return;
      }

      const isBlockingStepTypeExcludingModalAndQuestion =
        step.isBlockingStepType && !["modal", "question"].includes(step.attributes.type);

      if (isBlockingStepTypeExcludingModalAndQuestion && event === "disposed") {
        this.events.emit("finished", {});
        return;
      }
    });
  }

  clearCurrentStep() {
    this.stopListenStepEvents?.();
    this.currentStep = undefined;
  }

  stop() {
    this.stopListenStepEvents?.();
  }
}
